import type { DateRangeAvailability } from '../../shared/dateRangeAvailability';

export const availabilityLabels = {
  live: 'Live now',
  upcoming: 'Upcoming',
  expired: 'Expired',
  'inactive-today': 'Not active today',
  invalid: 'Invalid dates',
} as const;

export function getAvailabilityChipColor(availability: DateRangeAvailability) {
  switch (availability) {
    case 'live':
      return 'success' as const;
    case 'upcoming':
      return 'info' as const;
    case 'expired':
      return 'default' as const;
    default:
      return 'warning' as const;
  }
}
